module.exports = __webpack_public_path__ + "static/media/polishing_diamond_v2.2207f09d.webp";